import { ProductsService } from 'src/app/_services/products.service';
import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Platform } from '@angular/cdk/platform';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { GlobalService } from 'src/app/_services/global.service';
import { catchError, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { BusinessSetupService } from 'src/app/_services/business-setup.service';

@Component({
  selector: 'app-product-details-v4',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsV4Component implements OnInit {
  _global = GlobalService
  editform: FormGroup
  url: any = null;
  cartUrl: any = null;
  // url:any ="https://lincsell.com/";
  isUrlLoad: boolean = false;
  @Input() showUrlSection = true;
  constructor(
    public _productServices: ProductsService,
    private _fb: FormBuilder,
    public _platform: Platform,
    public _abd: AppBaseDataService,
    private _http: HttpClient,
    private _connMessageService: ConnMessageService,
    private clipboard: Clipboard,
    private _businessSetupService: BusinessSetupService,
  ) { this.initForm() }

  /** AI-editor stores publish directly to their own onlineStoreUrl (e.g. "you242.lincsell.com")
   *  rather than a WordPress multisite host, so there's no wp-json back-office-apis endpoint to
   *  hit for the product URL. */
  get onlineStoreUrl(): string {
    return String(
      GlobalService.userInfo?.businessSetup?.[0]?.onlineStoreUrl ??
      GlobalService.userInfo?.businessSetup?.[0]?.OnlineStoreUrl ??
      ''
    ).trim();
  }

  // Accounts with no active-editor flag set on the backend default to "AI" from
  // ai-editor/active-editor, but this specific account has no online-store editor configured
  // at all and should always resolve WordPress-style product URLs.
  private readonly forceWordPressEmails = ['younksnutritioncentral@yahoo.com'];

  ngOnInit(): void {
    this.initForm()
    if (!this._productServices.isNew && this._abd.selectedProductSellType.id != 2) {
      const email = String(GlobalService.userInfo?.email ?? '').trim().toLowerCase();
      if (this.forceWordPressEmails.includes(email)) {
        this.getUrl();
        return;
      }
      this._businessSetupService.getActiveEditorCached().subscribe((editor) => {
        if (String(editor).trim().toLowerCase().includes('ai')) {
          this.buildAiEditorUrls();
        } else {
          this.getUrl();
        }
      });
    }
  }
  copy(text: any) {
    this.clipboard.copy(text);
    this._connMessageService.showToastMessage('copied successfully', 'success');
  }

  /** Builds the product/cart links directly from the store's own domain (same
   *  {url}/products/{sku} and {url}/products/{sku}?add-to-cart pattern used on the live storefront)
   *  instead of going through the WordPress-only product-url lookup below. */
  private buildAiEditorUrls(): void {
    if (!this.onlineStoreUrl) {
      this.url = null;
      this.cartUrl = null;
      return;
    }
    const host = /^https?:\/\//i.test(this.onlineStoreUrl) ? this.onlineStoreUrl : `https://${this.onlineStoreUrl}`;
    const baseUrl = host.replace(/\/+$/, '');
    // The storefront resolves products by the item's real numeric id (activeItem.id/itemsId/
    // productCode, all the same value) — not skuCode/pts.sku, which is a separately generated
    // display SKU (see GlobalService.generateSKU()) that the storefront doesn't recognize.
    const activeItem = this._productServices.activeItem;
    const itemId = activeItem?.id ?? activeItem?.itemsId ?? activeItem?.productCode ?? this._productServices.pts.sku;
    this.url = `${baseUrl}/products/${itemId}`;
    this.cartUrl = `${this.url}?add-to-cart`;
  }

  getUrl() {
    this.isUrlLoad = true
    try {
      //  let url =  environment.BusinessBaseURL +'product-url?url='+ this._global.webStoreConfiguration?.webStoreHost+'/wp-json/back-office-apis/v1/product-url/?sku=1111111111'
      if (this._global.webStoreConfiguration?.webStoreHost != undefined) {
        let url = environment.AuthenticationURL + 'product-url?url=' + this._global.webStoreConfiguration?.webStoreHost + '/wp-json/back-office-apis/v1/product-url/?sku=' + this._productServices.pts.sku + '&method=GET'
        this._http.get<any>(url).subscribe({

          next: (res) => {
            this.isUrlLoad = false
            if (res.success) {
              this.url = res.data?.url;
              const addToCartParam = `add-to-cart=${this._productServices.pts.sku}`;
              const baseUrl = this.url || this._global.webStoreConfiguration?.webStoreHost;
              if (baseUrl) {
                const separator = baseUrl.includes('?') ? '&' : '?';
                this.cartUrl = `${baseUrl}${separator}${addToCartParam}`;
              } else {
                this.cartUrl = null;
              }
            } else {
              this.url = null
              this.cartUrl = null
              // this._connMessageService.showToastMessage('No Product url found!', 'error');
            }
          },
          error: (error) => {
            this.isUrlLoad = false
            console.error('Error fetching data:', error)
          }
        }
        )
      }
      else{
        this.isUrlLoad = false
      }

    } catch (error) {
      // console.log(error)
    }
  }

  initForm() {
    // alert(7667)
    this.editform = this._fb.group({
      productName: [{ value: this._productServices.pts.t_productName, disabled: this._productServices.isViewOnly }, Validators.required],
      descriptionUrl: [{ value: this._productServices.pts.descriptionUrl, disabled: this._productServices.isViewOnly }],
      //productDescription:['']
    })
  }

  isFormValid() {
    return this.editform.valid
  }





}
